<template>
  <div class="admin-console-page dash-board">
    <header class="console-page-head dash-head">
      <h2 class="console-title">대시보드</h2>
      <p class="console-desc">{{ todayLabel }}</p>
    </header>

    <div class="dash-grid">
      <div class="dash-col">
      <section class="console-panel dash-members">
        <div class="console-panel-head">
          <h3 class="console-panel-title">고객관리</h3>
          <button type="button" class="console-text-btn" aria-label="고객관리로 이동" @click="goMember">이동</button>
        </div>
        <div class="dash-panel-body">
          <label class="quick-find-field">
            <v-icon size="18">mdi-magnify</v-icon>
            <input
              v-model="memberKeyword"
              type="text"
              placeholder="시설명, 기관기호"
              @keydown="onMemberKey"
            />
          </label>
          <p v-if="memberBusy" class="dash-empty">{{ memberKeyword.trim() ? '찾는 중' : '불러오는 중' }}</p>
          <p v-else-if="!memberVisible.length" class="dash-empty">데이터가 없습니다</p>
          <template v-else>
            <ul class="quick-find-list">
              <li v-for="(item, index) in memberVisible" :key="item.m_idx">
                <button
                  type="button"
                  class="quick-find-row"
                  :class="{ 'is-active': !!memberKeyword.trim() && index === memberActive }"
                  @click="openMember(item)"
                  @mouseenter="memberActive = index"
                >
                  <span class="quick-find-name">{{ item.m_name }}</span>
                  <span class="quick-find-code">{{ item.m_longterm_code || '—' }}</span>
                </button>
              </li>
            </ul>
            <button v-if="memberHasMore" type="button" class="dash-more" @click="goMemberMore">더보기</button>
          </template>
        </div>
      </section>

      <section v-if="!isManagerAdmin" class="console-panel quick-find">
        <div class="console-panel-head">
          <h3 class="console-panel-title">시설검색</h3>
          <button type="button" class="console-text-btn" aria-label="시설검색으로 이동" @click="goFacility">이동</button>
        </div>
        <div class="dash-panel-body">
          <label class="quick-find-field">
            <v-icon size="18">mdi-magnify</v-icon>
            <input
              v-model="facilityKeyword"
              type="text"
              placeholder="시설명, 기관기호"
              @keydown="onFacilityKey"
            />
          </label>
          <p v-if="facilitySearching" class="dash-empty">찾는 중</p>
          <p v-else-if="!facilityVisible.length" class="dash-empty">데이터가 없습니다</p>
          <template v-else>
            <ul class="quick-find-list">
              <li v-for="(item, index) in facilityVisible" :key="item.cc_number">
                <button
                  type="button"
                  class="quick-find-row"
                  :class="{ 'is-active': index === facilityActive }"
                  @click="openFacility(item)"
                  @mouseenter="facilityActive = index"
                >
                  <span class="quick-find-name">{{ item.cc_name }}</span>
                  <span class="quick-find-code">{{ item.cc_number || '—' }}</span>
                </button>
              </li>
            </ul>
            <button v-if="facilityHasMore" type="button" class="dash-more" @click="goFacilityMore">더보기</button>
          </template>
        </div>
      </section>

      <section v-if="isManagerAdmin" class="console-panel dash-notices">
        <div class="console-panel-head">
          <h3 class="console-panel-title">공지사항</h3>
          <button type="button" class="console-text-btn" aria-label="게시판으로 이동" @click="goNotice">이동</button>
        </div>
        <div class="dash-panel-body">
          <div v-if="noticeLoading" class="dash-empty">불러오는 중</div>
          <div v-else-if="!notices.length" class="dash-empty">데이터가 없습니다</div>
          <ul v-else class="notice-list">
            <li v-for="item in notices" :key="item.idx">
              <button type="button" class="notice-row" @click="openNotice(item)">
                <span v-if="isNewNotice(item.createdAt)" class="notice-new">신규</span>
                <span v-if="item.pinned" class="notice-pin">고정</span>
                <span class="notice-title">{{ item.title }}</span>
                <span class="notice-meta">{{ formatDate(item.createdAt) }}</span>
              </button>
            </li>
          </ul>
        </div>
      </section>
      </div>

      <div class="dash-col">
      <section v-if="!isManagerAdmin" class="console-panel dash-notices">
        <div class="console-panel-head">
          <h3 class="console-panel-title">공지사항</h3>
          <button type="button" class="console-text-btn" aria-label="게시판으로 이동" @click="goNotice">이동</button>
        </div>
        <div class="dash-panel-body">
          <div v-if="noticeLoading" class="dash-empty">불러오는 중</div>
          <div v-else-if="!notices.length" class="dash-empty">데이터가 없습니다</div>
          <ul v-else class="notice-list">
            <li v-for="item in notices" :key="item.idx">
              <button type="button" class="notice-row" @click="openNotice(item)">
                <span v-if="isNewNotice(item.createdAt)" class="notice-new">신규</span>
                <span v-if="item.pinned" class="notice-pin">고정</span>
                <span class="notice-title">{{ item.title }}</span>
                <span class="notice-meta">{{ formatDate(item.createdAt) }}</span>
              </button>
            </li>
          </ul>
        </div>
      </section>

      <section v-if="isManagerAdmin" class="console-panel quick-find">
        <div class="console-panel-head">
          <h3 class="console-panel-title">시설검색</h3>
          <button type="button" class="console-text-btn" aria-label="시설검색으로 이동" @click="goFacility">이동</button>
        </div>
        <div class="dash-panel-body">
          <label class="quick-find-field">
            <v-icon size="18">mdi-magnify</v-icon>
            <input
              v-model="facilityKeyword"
              type="text"
              placeholder="시설명, 기관기호"
              @keydown="onFacilityKey"
            />
          </label>
          <p v-if="facilitySearching" class="dash-empty">찾는 중</p>
          <p v-else-if="!facilityVisible.length" class="dash-empty">데이터가 없습니다</p>
          <template v-else>
            <ul class="quick-find-list">
              <li v-for="(item, index) in facilityVisible" :key="item.cc_number">
                <button
                  type="button"
                  class="quick-find-row"
                  :class="{ 'is-active': index === facilityActive }"
                  @click="openFacility(item)"
                  @mouseenter="facilityActive = index"
                >
                  <span class="quick-find-name">{{ item.cc_name }}</span>
                  <span class="quick-find-code">{{ item.cc_number || '—' }}</span>
                </button>
              </li>
            </ul>
            <button v-if="facilityHasMore" type="button" class="dash-more" @click="goFacilityMore">더보기</button>
          </template>
        </div>
      </section>

      <section v-if="isManagerAdmin" class="console-panel dash-consult">
        <div class="console-panel-head">
          <h3 class="console-panel-title">상담요청</h3>
          <button type="button" class="console-text-btn" aria-label="상담요청으로 이동" @click="goConsult">이동</button>
        </div>
        <div class="dash-panel-body">
          <div v-if="consultLoading" class="dash-empty">불러오는 중</div>
          <div v-else-if="!consults.length" class="dash-empty">데이터가 없습니다</div>
          <ul v-else class="consult-list">
            <li v-for="item in consults" :key="item.id">
              <button type="button" class="consult-row" @click="goConsult">
                <span class="consult-state" :class="item.status === 'DONE' ? 'is-done' : 'is-wait'">
                  {{ item.status === 'DONE' ? '완료' : '대기' }}
                </span>
                <span class="consult-body">
                  <span class="consult-title">{{ item.title }}</span>
                  <span v-if="item.orgName" class="consult-org">{{ item.orgName }}</span>
                </span>
              </button>
            </li>
          </ul>
        </div>
      </section>

      <DashCalendar v-if="!isManagerAdmin" />
      </div>

      <DashCalendar v-if="isManagerAdmin" />
    </div>

    <v-dialog v-model="detailOpen" max-width="560">
      <v-card v-if="selected" class="notice-read-card">
        <div class="notice-read-head">
          <div class="notice-read-head-text">
            <p class="console-kicker">공지</p>
            <h3 class="notice-read-title">
              <span v-if="isNewNotice(selected.createdAt)" class="notice-new">신규</span>
              {{ selected.title }}
            </h3>
            <p class="notice-read-meta">
              {{ selected.authorName || '관리자' }} · {{ formatDateTime(selected.createdAt) }}
            </p>
          </div>
          <button
            type="button"
            class="notice-read-card__close"
            aria-label="닫기"
            @click="detailOpen = false"
          >
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </div>
        <BoardBody class="notice-read-body" :body="selected.body" />
        <div class="notice-read-actions">
          <v-btn variant="text" class="btn-close" @click="detailOpen = false">닫기</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { boardApi, consultBoardApi, crawlApi, memberApi } from '@/services/api';
import BoardBody from '@/components/admin/BoardBody.vue';
import DashCalendar from '@/components/admin/DashCalendar.vue';

interface NoticeItem {
  idx: number;
  title: string;
  body: string;
  pinned: boolean;
  authorName: string;
  createdAt: string | null;
}

interface MemberHit {
  m_idx: number;
  m_code: string;
  m_name: string;
  m_longterm_code: string;
}

interface FacilityHit {
  cc_number: string;
  cc_name: string;
}

interface ConsultHit {
  id: number;
  title: string;
  orgName: string;
  status: string;
}

const router = useRouter();
const store = useStore();

const isManagerAdmin = computed(() => Number(store.getters.roleLevel || 0) >= 80);

const notices = ref<NoticeItem[]>([]);
const noticeLoading = ref(false);
const detailOpen = ref(false);
const selected = ref<NoticeItem | null>(null);

const now = new Date();

const recentMembers = ref<MemberHit[]>([]);
const memberLoading = ref(false);
const memberKeyword = ref('');
const memberResults = ref<MemberHit[]>([]);
const memberTotal = ref(0);
const memberSearching = ref(false);
const memberActive = ref(0);
const memberBusy = computed(() => (memberKeyword.value.trim() ? memberSearching.value : memberLoading.value));
const memberVisible = computed(() => (memberKeyword.value.trim() ? memberResults.value.slice(0, 5) : recentMembers.value));
const memberHasMore = computed(() => !!memberKeyword.value.trim() && memberTotal.value > 5);

const facilityKeyword = ref('');
const facilityResults = ref<FacilityHit[]>([]);
const facilityTotal = ref(0);
const facilitySearching = ref(false);
const facilityActive = ref(0);
const facilityVisible = computed(() => facilityResults.value.slice(0, 5));
const facilityHasMore = computed(() => facilityTotal.value > 5);

const consults = ref<ConsultHit[]>([]);
const consultLoading = ref(false);

let facilityTimer: ReturnType<typeof setTimeout> | null = null;
let facilitySeq = 0;
let memberTimer: ReturnType<typeof setTimeout> | null = null;
let memberSeq = 0;

const todayLabel = computed(() => {
  const days = ['일', '월', '화', '수', '목', '금', '토'];
  return `${now.getFullYear()}년 ${now.getMonth() + 1}월 ${now.getDate()}일 ${days[now.getDay()]}요일`;
});

const NEW_NOTICE_MS = 7 * 24 * 60 * 60 * 1000;

const isNewNotice = (createdAt: string | null) => {
  if (!createdAt) return false;
  const posted = new Date(String(createdAt).replace(' ', 'T'));
  if (Number.isNaN(posted.getTime())) return false;
  const age = Date.now() - posted.getTime();
  return age >= 0 && age < NEW_NOTICE_MS;
};

const formatDate = (value: string | null) => (value ? String(value).substring(0, 10) : '');

const formatDateTime = (value: string | null) =>
  value ? String(value).substring(0, 16).replace('T', ' ') : '';

const loadNotices = async () => {
  noticeLoading.value = true;
  try {
    const res = await boardApi.notices();
    notices.value = (res.data?.data?.items || []).slice(0, 6);
  } catch (error) {
    notices.value = [];
  } finally {
    noticeLoading.value = false;
  }
};

const mapConsult = (row: ConsultHit): ConsultHit => ({
  id: row.id,
  title: row.title,
  orgName: row.orgName,
  status: row.status,
});

const loadConsults = async () => {
  if (!isManagerAdmin.value) return;
  consultLoading.value = true;
  try {
    const preview = 5;
    const waitingRes = await consultBoardApi.listRequests({ page: 1, limit: 10, status: 'WAIT' });
    const waiting = (waitingRes.data?.data?.items || []).slice(0, preview).map(mapConsult);
    let done: ConsultHit[] = [];
    if (waiting.length < preview) {
      const doneRes = await consultBoardApi.listRequests({ page: 1, limit: 10, status: 'DONE' });
      done = (doneRes.data?.data?.items || []).slice(0, preview - waiting.length).map(mapConsult);
    }
    consults.value = [...waiting, ...done];
  } catch (error) {
    consults.value = [];
  } finally {
    consultLoading.value = false;
  }
};

const loadRecentMembers = async () => {
  memberLoading.value = true;
  try {
    const res = await memberApi.getList({ sort: 'recent', page: 1, limit: 5 });
    const rows = Array.isArray(res.data?.data) ? res.data.data : [];
    recentMembers.value = rows.map((row: MemberHit) => ({
      m_idx: row.m_idx,
      m_code: row.m_code,
      m_name: row.m_name,
      m_longterm_code: row.m_longterm_code,
    }));
  } catch (error) {
    recentMembers.value = [];
  } finally {
    memberLoading.value = false;
  }
};

const searchMembers = async (text: string) => {
  const seq = ++memberSeq;
  memberSearching.value = true;
  try {
    const res = await memberApi.getList({ search: text, page: 1, limit: 5 });
    if (seq !== memberSeq) return;
    const rows = Array.isArray(res.data?.data) ? res.data.data : [];
    memberResults.value = rows.slice(0, 5).map((row: MemberHit) => ({
      m_idx: row.m_idx,
      m_code: row.m_code,
      m_name: row.m_name,
      m_longterm_code: row.m_longterm_code,
    }));
    memberTotal.value = Number(res.data?.pagination?.total ?? rows.length);
    memberActive.value = 0;
  } catch (error) {
    if (seq !== memberSeq) return;
    memberResults.value = [];
    memberTotal.value = 0;
  } finally {
    if (seq === memberSeq) memberSearching.value = false;
  }
};

const searchFacilities = async (text: string) => {
  const seq = ++facilitySeq;
  facilitySearching.value = true;
  try {
    const res = await crawlApi.getList({ search: text, page: 1, limit: 5 });
    if (seq !== facilitySeq) return;
    const rows = Array.isArray(res.data?.data) ? res.data.data : [];
    facilityResults.value = rows.slice(0, 5).map((row: FacilityHit) => ({
      cc_number: row.cc_number,
      cc_name: row.cc_name,
    }));
    facilityTotal.value = Number(res.data?.pagination?.total ?? rows.length);
    facilityActive.value = 0;
  } catch (error) {
    if (seq !== facilitySeq) return;
    facilityResults.value = [];
    facilityTotal.value = 0;
  } finally {
    if (seq === facilitySeq) facilitySearching.value = false;
  }
};

const openMember = (item: MemberHit) => {
  const height = window.screen.height;
  window.open(
    `/member/detail/${item.m_code}`,
    'memberDetailPopup',
    `width=2000,height=${height},left=0,top=0,scrollbars=yes,resizable=yes`
  );
};

const openFacility = (item: FacilityHit) => {
  window.open(
    `/facility/detail/${item.cc_number}`,
    'facilityDetailPopup',
    'width=1100,height=720,left=0,top=0,menubar=no,toolbar=no,location=yes,status=no,resizable=yes,scrollbars=yes'
  );
};

const bindSearchKey = (
  event: KeyboardEvent,
  results: { value: unknown[] },
  active: { value: number },
  open: (item: any) => void
) => {
  if (event.key === 'ArrowDown' && results.value.length) {
    event.preventDefault();
    active.value = (active.value + 1) % results.value.length;
  } else if (event.key === 'ArrowUp' && results.value.length) {
    event.preventDefault();
    active.value = (active.value - 1 + results.value.length) % results.value.length;
  } else if (event.key === 'Enter') {
    const hit = results.value[active.value];
    if (hit) open(hit);
  }
};

const onFacilityKey = (event: KeyboardEvent) => {
  bindSearchKey(event, facilityVisible, facilityActive, openFacility);
};

const onMemberKey = (event: KeyboardEvent) => {
  if (!memberKeyword.value.trim()) return;
  bindSearchKey(event, memberVisible, memberActive, openMember);
};

watch(memberKeyword, (value) => {
  if (memberTimer) clearTimeout(memberTimer);
  const text = value.trim();
  if (!text) {
    memberSeq += 1;
    memberResults.value = [];
    memberTotal.value = 0;
    memberSearching.value = false;
    memberActive.value = 0;
    return;
  }
  memberTimer = setTimeout(() => searchMembers(text), 180);
});

watch(facilityKeyword, (value) => {
  if (facilityTimer) clearTimeout(facilityTimer);
  const text = value.trim();
  if (!text) {
    facilitySeq += 1;
    facilityResults.value = [];
    facilityTotal.value = 0;
    facilitySearching.value = false;
    return;
  }
  facilityTimer = setTimeout(() => searchFacilities(text), 180);
});

const openNotice = (item: NoticeItem) => {
  selected.value = item;
  detailOpen.value = true;
};

const goNotice = () => router.push('/board');
const goMember = () => router.push('/member');
const goMemberMore = () => {
  const search = memberKeyword.value.trim();
  router.push(search ? { path: '/member', query: { search } } : '/member');
};
const goFacility = () => router.push('/facility');
const goFacilityMore = () => {
  const search = facilityKeyword.value.trim();
  router.push(search ? { path: '/facility', query: { search } } : '/facility');
};
const goConsult = () => router.push('/consult-requests');

onMounted(() => {
  loadRecentMembers();
  loadNotices();
  loadConsults();
});
</script>
